export const TEAMS_GET_PGC_POINTS = "TEAMS_GET_PGC_POINTS";
export const TEAMS_GET_PGC_POINTS_REQUESTED = "TEAMS_GET_PGC_POINTS_REQUESTED";
export const TEAMS_GET_PGC_POINTS_SUCCESS = "TEAMS_GET_PGC_POINTS_SUCCESS";
export const TEAMS_GET_PGC_POINTS_FAILED = "TEAMS_GET_PGC_POINTS_FAILED";
export const TEAMS_GET_PGC_POINTS_CLEAR = "TEAMS_GET_PGC_POINTS_CLEAR";
